
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: "mat-plant",
directives: {
TransferDom
},
components:{
PopupHeader,
Popup
},
data() {
return {
refresh:true,
wrapperHeight: 0,
allLoaded: false,
config: {
title: '物料工厂',
url: 'api/mat-plant/page'
},
list: [],
popupShow:false,
showData:{}
}
},
methods: {
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function () {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
},
viewDetail(data){
this.popupShow = true;
this.showData = data;
},
cancelPopup(){
this.popupShow = false;
}
},
mounted() {
if(this.$route.query.matId){
this.config = {
title: '物料工厂',
url: 'api/mat-plant/page',
property:'id',
fixRules: {
rules:[{
field:'material.id',
option:'IN',
values:[this.$route.query.matId],
}],
fixed:true
}
};
delete this.config.inputCondition;
}
this.init();
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/material-info-library/mat-plant.vue